import TopBar from "../../../components/LayoutComponent/TopBar/topBar";
import Tabbar from "../../../components/LayoutComponent/TabBar/Tabbar";
import "../userDashboard.css";
import UserProfileChangePasswordComp from "../../../components/userProfileComp/UserProfile-Change-Password-Comp";

export const UserChangePasswordPage = () => {
  return (
    <>
      <div className="w3-content" style={{ minHeight: "400px" }}>
        <TopBar
          showBackButton
          displayType="title"
          title="Change Password"
          showNotification
        ></TopBar>
        <UserProfileChangePasswordComp></UserProfileChangePasswordComp>
        <Tabbar menuType={"users"}></Tabbar>
      </div>
    </>
  );
};

export default UserChangePasswordPage;
